export const LEGACY_PERMISSION_SUPPORT_LEVEL = 1;
export const PLATFORM_PERMISSION_SUPPORT_LEVEL = 2;

export const NESTED_PERMISSIONS_PADDING = 8;

export const SELECTED_STATE = 2;
export const DESELECTED_STATE = 0;
export const PARTIAL_SELECTED_STATE = 1;
